export default "__VITE_ASSET__16LbeiyS__"